// extracted by mini-css-extract-plugin
export var active = "_as-d";
export var blink = "_as-e";
export var container = "_as-5";
export var controls = "_as-0";
export var controlsRight = "_as-1";
export var fakeCursor = "_as-c";
export var hidden = "_as-b";
export var quillContainerSmall = "_as-7";
export var quillEditor = "_as-6";
export var quillEditorSmall = "_as-8";
export var quillFormatButtons = "_as-a";
export var quillToolbar = "_as-9";
export var removePadding = "_as-2";
export var state = "_as-3";
export var stateTitle = "_as-4";